// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Float from "@rescript/core/src/Core__Float.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as Modal$OrcaPaymentPage from "../Components/Modal.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "../Components/RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";

function getKeyValue(json, str) {
  return Core__Option.getOr(Core__JSON.Decode.string(Core__Option.getOr(json[str], {})), "");
}

function parsePaymentMethod(methodString) {
  if (methodString === "duit_now") {
    return "DuitNow";
  } else {
    return "Other";
  }
}

let baseConfig = {
  defaultColor: "transparent",
  showBorder: false,
  footerText: "",
  showLogo: false,
  color: "",
  logoName: ""
};

function getPaymentMethodConfig(method) {
  if (method === "DuitNow") {
    return {
      defaultColor: "#ED2E67",
      showBorder: true,
      footerText: "MALAYSIA NATIONAL QR",
      showLogo: true,
      color: "",
      logoName: "duitNow"
    };
  } else {
    return baseConfig;
  }
}

function QRCodeDisplay(props) {
  let match = React.useState(() => "");
  let setQrCode = match[1];
  let match$1 = React.useState(() => "");
  let setRawQrData = match$1[1];
  let rawQrData = match$1[0];
  let match$2 = React.useState(() => false);
  let setIsCopied = match$2[1];
  let match$3 = React.useState(() => 900000.0);
  let setExpiryTime = match$3[1];
  let expiryTime = match$3[0];
  let match$4 = React.useState(() => false);
  let setOpenModal = match$4[1];
  let match$5 = React.useState(() => "");
  let setReturnUrl = match$5[1];
  let return_url = match$5[0];
  let match$6 = React.useState(() => "");
  let setClientSecret = match$6[1];
  let clientSecret = match$6[0];
  let match$7 = React.useState(() => "");
  let setSdkAuthorization = match$7[1];
  let sdkAuthorization = match$7[0];
  let match$8 = React.useState(() => []);
  let setHeaders = match$8[1];
  let headers = match$8[0];
  let match$9 = React.useState(() => "");
  let setPublishableKey = match$9[1];
  let publishableKey = match$9[0];
  let logger = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let customPodUri = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.customPodUri);
  let match$10 = React.useState(() => baseConfig);
  let setPaymentMethodConfig = match$10[1];
  let paymentMethodConfig = match$10[0];
  let copyTimeoutRef = React.useRef(undefined);
  React.useEffect(() => {
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
        "iframeMountedCallback",
        true
      ]]);
    let handle = ev => {
      let handleAsync = async () => {
        let json = Utils$OrcaPaymentPage.safeParse(ev.data);
        let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
        if (!Core__Option.isSome(dict["fullScreenIframeMounted"])) {
          return;
        }
        let metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
        let metaDataDict = Core__Option.getOr(Core__JSON.Decode.object(metadata), {});
        let paymentMethodStr = Utils$OrcaPaymentPage.getString(metaDataDict, "paymentMethod", "");
        let parsedPaymentMethod = parsePaymentMethod(paymentMethodStr);
        let defaultConfig = getPaymentMethodConfig(parsedPaymentMethod);
        let qrData = Utils$OrcaPaymentPage.getString(metaDataDict, "qrData", "");
        let rawQrData = Utils$OrcaPaymentPage.getString(metaDataDict, "rawQrData", "");
        let publishableKey = Utils$OrcaPaymentPage.getString(metaDataDict, "publishableKey", "");
        setPublishableKey(param => publishableKey);
        setQrCode(param => qrData);
        setRawQrData(param => rawQrData);
        if (parsedPaymentMethod === "DuitNow") {
          let displayText = Utils$OrcaPaymentPage.getString(metaDataDict, "display_text", defaultConfig.footerText);
          let borderColor = Utils$OrcaPaymentPage.getString(metaDataDict, "border_color", defaultConfig.defaultColor);
          let displayText$1 = displayText === "" ? defaultConfig.footerText : displayText;
          let borderColor$1 = borderColor === "" ? defaultConfig.defaultColor : borderColor;
          let showBorder = displayText$1 !== "" && borderColor$1 !== "";
          setPaymentMethodConfig(param => ({
            defaultColor: defaultConfig.defaultColor,
            showBorder: showBorder,
            footerText: displayText$1,
            showLogo: defaultConfig.showLogo,
            color: borderColor$1,
            logoName: defaultConfig.logoName
          }));
        } else {
          setPaymentMethodConfig(param => defaultConfig);
        }
        let paymentIntentId = Utils$OrcaPaymentPage.getString(metaDataDict, "paymentIntentId", "");
        setClientSecret(param => paymentIntentId);
        let sdkAuthorizationVal = Utils$OrcaPaymentPage.getString(metaDataDict, "sdkAuthorization", "");
        setSdkAuthorization(param => sdkAuthorizationVal);
        let headersDict = Core__Option.getOr(Core__JSON.Decode.object(Utils$OrcaPaymentPage.getJsonObjectFromDict(metaDataDict, "headers")), {});
        let headers = {};
        setReturnUrl(param => Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(metadata), "url", ""));
        Object.entries(headersDict).forEach(entries => {
          headers[entries[0]] = Utils$OrcaPaymentPage.getStringFromJson(entries[1], "");
        });
        let expiryTime = Core__Option.getOr(Core__Float.fromString(Utils$OrcaPaymentPage.getString(metaDataDict, "expiryTime", "")), 0.0);
        let timeExpiry = expiryTime - Date.now();
        if (timeExpiry > 0.0 && timeExpiry < 900000.0) {
          setExpiryTime(param => timeExpiry);
        }
        setHeaders(param => Object.entries(headers));
        try {
          let res = await PaymentHelpers$OrcaPaymentPage.pollRetrievePaymentIntent(paymentIntentId, Object.fromEntries(Object.entries(headers)), publishableKey, logger, customPodUri, undefined, Primitive_option.some(sdkAuthorizationVal));
          Modal$OrcaPaymentPage.close(setOpenModal);
          return Utils$OrcaPaymentPage.postSubmitResponse(res, return_url);
        } catch (raw_error) {
          let error = Primitive_exceptions.internalToException(raw_error);
          console.error("Error while polling payment intent:", error);
          return;
        }
      };
      handleAsync();
    };
    window.addEventListener("message", handle);
    return () => {
      window.removeEventListener("message", handle);
    };
  }, []);
  let closeModal = async () => {
    try {
      let json = await PaymentHelpers$OrcaPaymentPage.retrievePaymentIntent(clientSecret, Object.fromEntries(headers), publishableKey, logger, customPodUri, undefined, Primitive_option.some(sdkAuthorization));
      Utils$OrcaPaymentPage.postSubmitResponse(json, return_url);
      return Modal$OrcaPaymentPage.close(setOpenModal);
    } catch (raw_e) {
      let e = Primitive_exceptions.internalToException(raw_e);
      console.error("Retrieve Failed", e);
      return;
    }
  };
  React.useEffect(() => {
    if (expiryTime < 1000.0) {
      closeModal();
    }
    let intervalID = setInterval(() => setExpiryTime(prev => prev - 1000.0), 1000);
    return () => {
      clearInterval(intervalID);
    };
  }, [expiryTime]);
  let expiryString = React.useMemo(() => {
    let minutes = (expiryTime / 60000.0 | 0).toString();
    let seconds = ((expiryTime | 0) % 60000 / 1000 | 0).toString();
    let formatedSeconds = seconds.length === 1 ? `0` + seconds : seconds;
    return minutes + `:` + formatedSeconds;
  }, [expiryTime]);
  let handleCopyQrData = param => {
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [
      [
        "copy",
        true
      ],
      [
        "copyDetails",
        rawQrData
      ]
    ]);
    let id = copyTimeoutRef.current;
    if (id !== undefined) {
      clearTimeout(Primitive_option.valFromOption(id));
    }
    setIsCopied(param => true);
    let id$1 = setTimeout(() => {
      setIsCopied(param => false);
      copyTimeoutRef.current = undefined;
    }, 1000);
    copyTimeoutRef.current = Primitive_option.some(id$1);
  };
  let displayColor = React.useMemo(() => {
    if (!Utils$OrcaPaymentPage.isValidHexColor(paymentMethodConfig.color) || paymentMethodConfig.color === "") {
      return paymentMethodConfig.defaultColor;
    } else {
      return paymentMethodConfig.color;
    }
  }, [
    paymentMethodConfig.color,
    paymentMethodConfig.defaultColor
  ]);
  let isRawQrDataAvailable = rawQrData.length > 0;
  let qrBottomSectionMarginClass = isRawQrDataAvailable ? "mt-6" : "mt-16";
  return JsxRuntime.jsx(Modal$OrcaPaymentPage.make, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
          condition: paymentMethodConfig.showLogo && paymentMethodConfig.logoName !== "",
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
              name: paymentMethodConfig.logoName,
              size: 84,
              width: 84
            }),
            className: "flex flex-row w-full justify-center items-start mb-2"
          })
        }),
        JsxRuntime.jsx("div", {
          children: expiryString,
          className: "flex flex-row w-full justify-center items-start mb-8 font-medium text-2xl font-semibold text-[#151A1F] opacity-50"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("img", {
                style: {
                  height: "13rem"
                },
                alt: "",
                src: match[0]
              }),
              className: paymentMethodConfig.showBorder ? "border-[0.5em] border-white rounded-md" : ""
            }),
            JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
              condition: paymentMethodConfig.footerText !== "",
              children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("p", {
                  children: paymentMethodConfig.footerText
                }),
                className: "font-bold flex justify-center items-end text-[1em] text-white h-[2em]",
                style: {
                  backgroundColor: displayColor
                }
              })
            })
          ],
          className: paymentMethodConfig.showBorder ? "border-[1em] rounded-md" : "",
          style: {
            backgroundColor: paymentMethodConfig.showBorder ? displayColor : "transparent",
            borderColor: paymentMethodConfig.showBorder ? displayColor : "transparent"
          }
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
              condition: isRawQrDataAvailable,
              children: JsxRuntime.jsx("button", {
                children: match$2[0] ? "Copied!" : "Copy QR Data",
                className: "button mb-6 p-2 h-[40px] border border-[#006DF9] rounded-md",
                style: {
                  background: "transparent",
                  color: "#006DF9"
                },
                onClick: handleCopyQrData
              })
            }),
            JsxRuntime.jsx("div", {
              children: "The QR Code is valid for the next 15 minutes, please do not close until you have successfully completed the payment, after which you will be automatically redirected.",
              className: `Disclaimer w-full  font-medium text-xs text-[#151A1F] opacity-50`
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("button", {
                  children: "Done",
                  className: "w-full mt-6 p-2 h-[40px]",
                  style: {
                    background: "#006DF9",
                    borderRadius: "4px",
                    color: "#ffffff"
                  },
                  onClick: param => {
                    closeModal();
                  }
                })
              }),
              className: "button w-full"
            })
          ],
          className: `flex flex-col ` + qrBottomSectionMarginClass + ` max-w-md justify-between items-center`
        })
      ],
      className: "flex flex-col h-full justify-between items-center"
    }),
    showClose: false,
    setOpenModal: setOpenModal,
    openModal: match$4[0]
  });
}

let copyResetTime = 1000;

let maxQRTime = 900000.0;

let make = QRCodeDisplay;

export {
  copyResetTime,
  maxQRTime,
  getKeyValue,
  parsePaymentMethod,
  baseConfig,
  getPaymentMethodConfig,
  make,
}
/* jotai Not a pure module */
